






























































































































































































import { Component, Vue } from 'vue-property-decorator';
import { PeriodicBillSearchResponse, PeriodicBillOverviewResponse } from '@/models/periodicBillResponse';
import { EnabledTypes } from '@/enums/enabledTypes';
import { BillTypes } from '@/enums/billTypes';
import { BillStatusTypes, getBillStatusTypeName } from '@/enums/billStatusTypes';
import { getPaymentStatusTypeName, PaymentStatusTypes } from '@/enums/paymentStatusTypes';
import Axios from 'axios';
import moment from 'moment';
import { BillSearchRequest } from '@/models/billRequest';
import { getGradeYearName } from '@/enums/gradeYears';
import { BillData } from '@/models/billData';
import AvaivaledVue from '@/components/avaivaled.vue';
import { FunctionTypes } from '@/enums/functionTypes';
import { CollectionAgencyTypes } from '@/enums/collectionAgencyTypes';

@Component({})
export default class PeriodicBillList extends AvaivaledVue {
  private EnabledTypes = EnabledTypes;
  private BillTypes = BillTypes;
  private BillStatusTypes = BillStatusTypes;
  private getBillStatusTypeName = getBillStatusTypeName;
  private PaymentStatusTypes = PaymentStatusTypes;
  private getGradeYearName = getGradeYearName;

  private isLoading: boolean = false;
  private periodicBillList: PeriodicBillOverviewResponse[] = [];
  private countAll: number = 0;

  private showSearchCondition = true;

  private checkedBillList: string[] = [];

  get condition() {
    return this.$store.state.bill.periodicBillCondition;
  }

  get collectionAgency(): CollectionAgencyTypes {
    if (!this.user || !this.user.collectionAgency) {
      return CollectionAgencyTypes.None;
    }
    return this.user.collectionAgency;
  }

  get isPaypal() {
    switch (this.collectionAgency) {
      case CollectionAgencyTypes.PayPalAndCramSchool:
      case CollectionAgencyTypes.PayPalAndOther:
        return true;
      default:
        return false;
    }
  }

  public async created() {
    const ok = await this.pageBackCheck(FunctionTypes.Bill);
    if (!ok) {
      return;
    }
  }

  public async mounted() {
    await this.loadData();
  }

  private deactivated() {
    this.$destroy();
  }

  private async loadData() {
    this.isLoading = true;

    try {
      const req: BillSearchRequest = {
        perPage: this.condition.perPage,
        page: this.condition.page,
        sort: this.condition.sort,
        enabled: this.condition.enabledType === EnabledTypes.None
          ? null
          : this.condition.enabledType === EnabledTypes.Enabled,
        billType: this.condition.billType || null,
        billStatus: this.condition.billStatus,
        paymentStatus: this.condition.paymentStatus || null,
        readType: null,
        billDateFrom: this.condition.billDateFrom,
        billDateTo: this.condition.billDateTo,
        billLimitDateFrom: this.condition.billLimitDateFrom,
        billLimitDateTo: this.condition.billLimitDateTo,
        ordinarySchoolId: this.condition.ordinarySchoolId,
        gradeYear: this.condition.gradeYear,
        tagList: this.condition.tagList,
        keyWord: this.condition.keyWord,
      };
      const res = await Axios.post<PeriodicBillSearchResponse>('/api/periodic-bills', req);
      this.periodicBillList = res.data.periodicBills;
      this.countAll = res.data.countAll;
    } catch (error) {
      this.periodicBillList = [];
    }

    this.isLoading = false;
  }

  private getRowNumber(index: number) {
    return this.condition.perPage * (this.condition.page - 1) + index + 1;
  }

  private getBillStatusTagType(billStatusType: BillStatusTypes): string {
    switch (billStatusType) {
      case BillStatusTypes.Billed:
        return 'success';
      case BillStatusTypes.Unbilled:
      default:
        return 'danger';
    }
  }

  private formatBillDate(row: PeriodicBillOverviewResponse) {
    if (row.billDateCreationMonth === null) {
      return '未指定';
    }

    switch (row.billDateCreationMonth) {
      case 0:
        return `当月 ${row.billDateCreationDay}日`;
      case 1:
        return `翌月 ${row.billDateCreationDay}日`;
      case 2:
        return `翌々月 ${row.billDateCreationDay}日`;
      default:
        return '未指定';
    }
  }

  private formatBillLimitDate(row: PeriodicBillOverviewResponse) {
    if (row.billLimitDateCreationMonth === null) {
      return '未指定';
    }

    switch (row.billLimitDateCreationMonth) {
      case 0:
        return `当月 ${row.billLimitDateCreationDay}日`;
      case 1:
        return `翌月 ${row.billLimitDateCreationDay}日`;
      case 2:
        return `翌々月 ${row.billLimitDateCreationDay}日`;
      default:
        return '未指定';
    }
  }

  private onChangeSelection(selection: PeriodicBillOverviewResponse[]) {
    this.checkedBillList = selection.map((value) => value.periodicBillId);
  }

  private onChangeCondition() {
    this.condition.page = 1;
    this.loadData();
  }

  private onChangePage() {
    this.loadData();
  }

  private onChangeSort( {prop, order}: any ) {
    if (!prop) {
      this.condition.sort = '';
    } else {
      this.condition.sort = `${prop} ${order}`;
    }
    this.loadData();
  }

  private onPageSizeChange(val: number) {
    this.condition.perPage = val;
  }

  private onRowClick(row: PeriodicBillOverviewResponse, column: any) {
    switch (column.property) {
      case 'check':
      case 'paymentStatus':
        return;
    }
    this.$router.push(`/bill/periodic-bills/${row.periodicBillId}`);
  }

  private onCreateBill() {
    this.$router.push('/bill/periodic-bills/create');
  }

  private onBulkCreateBill() {
    const targetPeriodicBillList = this.periodicBillList
      .filter((billData) =>
        !billData.disabled
        && this.checkedBillList.some((billId) => billId === billData.periodicBillId)
      );

    if (targetPeriodicBillList.length === 0) {
      this.$notify.error({
        title: '請求書一括作成エラー',
        message: '作成可能な定期請求が選択されていません。',
        position: 'bottom-right'
      });
      return;
    }

    this.$router.push({ path: `/bill/bills/create?periodic-id=${
      targetPeriodicBillList.map((billData) => billData.periodicBillId).join(',')
    }` });
  }

  private async onBulkDeleteBill() {
    const targetPeriodicBillList = this.periodicBillList
      .filter((billData) =>
        !billData.disabled
        && this.checkedBillList.some((billId) => billId === billData.periodicBillId)
      );

    if (targetPeriodicBillList.length === 0) {
      this.$notify.error({
        title: '一括削除エラー',
        message: '削除可能な定期請求が選択されていません。',
        position: 'bottom-right'
      });
      return;
    }

    try {
      const message = targetPeriodicBillList.length < this.checkedBillList.length
        ? `選択中の内、削除可能な定期請求（${targetPeriodicBillList.length}件）を削除します。よろしいですか？`
        : `選択中の定期請求（${targetPeriodicBillList.length}件）を削除します。よろしいですか？`;

      await this.$confirm(message, '一括削除確認', {
        confirmButtonText: '一括削除',
        cancelButtonText: 'キャンセル',
        type: 'info',
        dangerouslyUseHTMLString: true
      });
    } catch (error) {
      return;
    }

    try {
      await Axios.delete('/api/periodic-bills/bulk-delete-bill', {
        data: {
          periodicBillIds: targetPeriodicBillList.map((item) => item.periodicBillId),
        }
      });

      this.$router.push({ name: 'PeriodicBillList' });

      this.$notify.success({
        title: '一括削除完了',
        message: '一括削除しました。',
        position: 'bottom-right',
      });
    } catch (error) {
      this.$notify.error({
        title: '一括削除エラー',
        message:
          (error.response && error.response.data) || '一括削除が失敗しました。',
        position: 'bottom-right',
      });
    }

    this.loadData();
  }

}
